import { CombinedMmmModelOutput } from '../models/mmm-model-output';

export const sortRows = (
  rows: CombinedMmmModelOutput[],
  idToSort: string,
  isDesc: boolean
): CombinedMmmModelOutput[] => {
  switch (idToSort) {
    case 'channel':
      return isDesc
        ? rows.sort((a, b) => b.segmentValue.localeCompare(a.segmentValue))
        : rows.sort((a, b) => a.segmentValue.localeCompare(b.segmentValue));
    case 'spend':
      return isDesc
        ? rows.sort((a, b) => b.spendPrimary! - a.spendPrimary!)
        : rows.sort((a, b) => a.spendPrimary! - b.spendPrimary!);
    case 'revenue':
      return isDesc
        ? rows.sort((a, b) => b.revenuePrimary! - a.revenuePrimary!)
        : rows.sort((a, b) => a.revenuePrimary! - b.revenuePrimary!);
    case 'roas':
      return isDesc
        ? rows.sort((a, b) => b.roasPrimary! - a.roasPrimary!)
        : rows.sort((a, b) => a.roasPrimary! - b.roasPrimary!);
    case 'mroas':
      return isDesc
        ? rows.sort((a, b) => b.mROASPrimary! - a.mROASPrimary!)
        : rows.sort((a, b) => a.mROASPrimary! - b.mROASPrimary!);
    case 'spend-primary':
      return isDesc
        ? rows.sort((a, b) => b.spendPrimary! - a.spendPrimary!)
        : rows.sort((a, b) => a.spendPrimary! - b.spendPrimary!);
    case 'revenue-primary':
      return isDesc
        ? rows.sort((a, b) => b.revenuePrimary! - a.revenuePrimary!)
        : rows.sort((a, b) => a.revenuePrimary! - b.revenuePrimary!);
    case 'roas-primary':
      return isDesc
        ? rows.sort((a, b) => b.roasPrimary! - a.roasPrimary!)
        : rows.sort((a, b) => a.roasPrimary! - b.roasPrimary!);
    case 'mroas-primary':
      return isDesc
        ? rows.sort((a, b) => b.mROASPrimary! - a.mROASPrimary!)
        : rows.sort((a, b) => a.mROASPrimary! - b.mROASPrimary!);
    case 'spend-compared':
      return isDesc
        ? rows.sort((a, b) => b.spendCompared! - a.spendCompared!)
        : rows.sort((a, b) => a.spendCompared! - b.spendCompared!);
    case 'revenue-compared':
      return isDesc
        ? rows.sort((a, b) => b.revenueCompared! - a.revenueCompared!)
        : rows.sort((a, b) => a.revenueCompared! - b.revenueCompared!);
    case 'roas-compared':
      return isDesc
        ? rows.sort((a, b) => b.roasCompared! - a.roasCompared!)
        : rows.sort((a, b) => a.roasCompared! - b.roasCompared!);
    case 'mroas-compared':
      return isDesc
        ? rows.sort((a, b) => b.mROASCompared! - a.mROASCompared!)
        : rows.sort((a, b) => a.mROASCompared! - b.mROASCompared!);
    default:
      return rows;
  }
};

export const createTotalRow: (
  rows: CombinedMmmModelOutput[]
) => CombinedMmmModelOutput = (rows) => {
  return {
    segmentValue: 'Total',
    spendPrimary: rows.reduce((acc, obj) => acc + (obj.spendPrimary ?? 0), 0),
    spendCompared: rows.reduce((acc, obj) => acc + (obj.spendCompared ?? 0), 0),
    revenuePrimary: rows.reduce(
      (acc, obj) => acc + (obj.revenuePrimary ?? 0),
      0
    ),
    revenueCompared: rows.reduce(
      (acc, obj) => acc + (obj.revenueCompared ?? 0),
      0
    ),
    roasPrimary: rows.reduce(
      (acc, obj) => acc + (obj.roasPrimary ?? 0) / rows.length,
      0
    ),
    roasCompared: rows.reduce(
      (acc, obj) => acc + (obj.roasCompared ?? 0) / rows.length,
      0
    ),
    mROASPrimary: rows.reduce(
      (acc, obj) => acc + (obj.mROASPrimary ?? 0) / rows.length,
      0
    ),
    mROASCompared: rows.reduce(
      (acc, obj) => acc + (obj.mROASCompared ?? 0) / rows.length,
      0
    )
  } as CombinedMmmModelOutput;
};
